import { render, staticRenderFns } from "./secondHeader.vue?vue&type=template&id=f9dc5182&"
import script from "./secondHeader.vue?vue&type=script&lang=js&"
export * from "./secondHeader.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports